/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Back_To_Sign_InInputs */

const en_two_fa_back_to_sign_in = /** @type {(inputs: Two_Fa_Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign in`)
};

const nl_two_fa_back_to_sign_in = /** @type {(inputs: Two_Fa_Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar inloggen`)
};

/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Two_Fa_Back_To_Sign_InInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_back_to_sign_in = /** @type {((inputs?: Two_Fa_Back_To_Sign_InInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Back_To_Sign_InInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_back_to_sign_in(inputs)
	return en_two_fa_back_to_sign_in(inputs)
});